import React from "react";
import { Link } from "react-router-dom";
import PharmacyHeader from "../PharmacyHeader";
import { rxRoute } from "../../../helpers/formatting";
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";
import * as msgs from "../../../constants/textConstants";

export default class TransferOptions extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Rx.BSWTransferOptions.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {

        return (
            <div className="container-fluid body-content transfer-landing-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <PharmacyHeader />
                        <div className="row transfer-landing__heading">
                            <div className="col-12 text-center">
                                <div className="step-heading-icon"><div className="svg-transfer" /></div>
                                <h2 className="step-heading">Where are your prescriptions?</h2>
                            </div>
                        </div>
                        <div className="row row-card-eq transfer-landing__body">
                            <div className="col-12 col-lg-6">
                                <div className="card non-bsw-transfer-card">
                                    <div className="card-header">
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="card-heading">At a Non-BSW Pharmacy</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-12">
                                                <div>Transfer from a Non-BSW Pharmacy e.g. CVS, Walgreens, Kroger, etc.</div>
                                            </div>
                                        </div>
                                    </div>
                                    <Link to={{ pathname: rxRoute('nonBswTransfer') }} className="card-block-link" ><span /></Link>
                                </div>
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className="card bsw-transfer-card">
                                    <div className="card-header">
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="card-heading">At a {msgs.PharmacyTileName}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-12">
                                                <div>Transfer from a {msgs.PharmacyTileName} to a {msgs.PharmacyTileName}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <Link to={{ pathname: rxRoute('bswTransfer') }} className="card-block-link" ><span /></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}